// Stitch per-clip voice takes into one mono WAV, each take starting at its clip's timeline offset.
// clips: [{ url: dataUrl, start: seconds, maxDur: seconds }]
export async function stitchClipTakes(clips) {
  const RATE = 22050;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  const ctx = new Ctx();
  const decoded = [];
  try {
    for (const c of clips) {
      const buf = await (await fetch(c.url)).arrayBuffer();
      decoded.push({ ...c, audio: await ctx.decodeAudioData(buf) });
    }
  } finally { ctx.close().catch(() => {}); }
  const end = Math.max(...decoded.map((d) => d.start + Math.min(d.audio.duration, d.maxDur)));
  const out = new Float32Array(Math.ceil(end * RATE));
  for (const d of decoded) {
    const n = Math.min(d.audio.duration, d.maxDur);
    const ch = d.audio.numberOfChannels;
    const step = d.audio.sampleRate / RATE;
    const base = Math.round(d.start * RATE);
    for (let i = 0; i < Math.floor(n * RATE) && base + i < out.length; i++) {
      const si = Math.floor(i * step);
      let v = 0;
      for (let c = 0; c < ch; c++) v += d.audio.getChannelData(c)[si] || 0;
      out[base + i] += v / ch;
    }
  }
  return wavDataUrl(out, RATE);
}

function wavDataUrl(samples, rate) {
  const buf = new ArrayBuffer(44 + samples.length * 2);
  const v = new DataView(buf);
  const w = (o, s) => { for (let i = 0; i < s.length; i++) v.setUint8(o + i, s.charCodeAt(i)); };
  w(0, "RIFF"); v.setUint32(4, 36 + samples.length * 2, true); w(8, "WAVE"); w(12, "fmt ");
  v.setUint32(16, 16, true); v.setUint16(20, 1, true); v.setUint16(22, 1, true);
  v.setUint32(24, rate, true); v.setUint32(28, rate * 2, true); v.setUint16(32, 2, true); v.setUint16(34, 16, true);
  w(36, "data"); v.setUint32(40, samples.length * 2, true);
  for (let i = 0; i < samples.length; i++) {
    const s = Math.max(-1, Math.min(1, samples[i]));
    v.setInt16(44 + i * 2, s < 0 ? s * 0x8000 : s * 0x7fff, true);
  }
  let bin = "";
  const bytes = new Uint8Array(buf);
  for (let i = 0; i < bytes.length; i += 0x8000) bin += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
  return `data:audio/wav;base64,${btoa(bin)}`;
}
